module.exports = __webpack_public_path__ + "media/components/spaces/icon-spaces-hero-8d20ebaa145db6522db13acad0ba1f2b.png";